import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  ITaskSiteOpeningHoursDisplay,
  SiteOpeningHoursService,
} from '../../services/site-opening-hours.service';
import { FormArray, FormGroup } from '@angular/forms';
import { SiteOpeningHoursForm } from '../../interfaces/customer-sites';
import { IVehicleAddress } from '../../interfaces/task-info';

@Component({
  selector: 'site-opening-hours-panel',
  templateUrl: './site-opening-hours-panel.component.html',
})
export class SiteOpeningHoursPanelComponent {
  @Input() taskSiteOpeningHours: ITaskSiteOpeningHoursDisplay;

  @Input() pickupLocation: IVehicleAddress;

  @Input() dropOffLocation: IVehicleAddress;

  @Input() editAllowed: boolean;

  public editVisible: boolean = false;
  public pickupSiteHoursFormGroup: FormArray<FormGroup<SiteOpeningHoursForm>>;
  public dropOffSiteHoursFormGroup: FormArray<FormGroup<SiteOpeningHoursForm>>;

  @Input() taskId: number;

  @Output() updated: EventEmitter<ITaskSiteOpeningHoursDisplay> =
    new EventEmitter<ITaskSiteOpeningHoursDisplay>();

  constructor(private siteOpeningHoursService: SiteOpeningHoursService) {
    this.pickupSiteHoursFormGroup = this.siteOpeningHoursService.createForm([], true);
    this.dropOffSiteHoursFormGroup = this.siteOpeningHoursService.createForm([], true);
  }

  editHours() {
    this.siteOpeningHoursService.patchFormFromDisplay(
      this.pickupSiteHoursFormGroup,
      this.taskSiteOpeningHours.pickup,
    );
    this.siteOpeningHoursService.patchFormFromDisplay(
      this.dropOffSiteHoursFormGroup,
      this.taskSiteOpeningHours.dropOff,
    );
    this.editVisible = true;
  }

  async saveOpeniningHours() {
    const response = await this.siteOpeningHoursService.updateTaskSiteOpeningHours(this.taskId, {
      pickup: this.siteOpeningHoursService.getOpeningHours(this.pickupSiteHoursFormGroup),
      dropOff: this.siteOpeningHoursService.getOpeningHours(this.dropOffSiteHoursFormGroup),
    });
    this.updated.emit(response);
    this.editVisible = false;
  }
}
